module.exports = __webpack_public_path__ + "media/stylesheets/images/belcy_logo-40bee56ea0a1cfe444f47ea81da5bda1.svg";